interface FilterOption {
  value: string;
  label: string;
}

interface ShopFiltersProps {
  sortOptions: FilterOption[];
  sortValue: string;
  onSortChange: (v: string) => void;
  filterGroups?: {
    label: string;
    key: string;
    options: FilterOption[];
    value: string;
    onChange: (v: string) => void;
  }[];
  totalCount: number;
  searchValue?: string;
  onSearchChange?: (v: string) => void;
}

const ShopFilters = ({
  sortOptions,
  sortValue,
  onSortChange,
  filterGroups = [],
  totalCount,
  searchValue = '',
  onSearchChange,
}: ShopFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-10 pb-6 border-b border-white/10">
      {/* Left: count + search */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-white/40 text-xs tracking-widest uppercase whitespace-nowrap">
          {totalCount} {totalCount === 1 ? 'produto' : 'produtos'}
        </p>
        {onSearchChange !== undefined && (
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-white/30 text-sm"></i>
            <input
              type="text"
              value={searchValue}
              onChange={e => onSearchChange(e.target.value)}
              placeholder="Buscar produto..."
              className="bg-white/5 border border-white/10 text-white text-xs placeholder-white/30 rounded-md pl-9 pr-4 py-2.5 focus:outline-none focus:border-[#c9a84c]/50 transition-colors w-52"
            />
          </div>
        )}
      </div>

      {/* Right: filter groups + sort */}
      <div className="flex flex-wrap items-center gap-3">
        {filterGroups.map(group => (
          <div key={group.key} className="flex items-center gap-2">
            <span className="text-white/30 text-xs tracking-widest uppercase whitespace-nowrap hidden sm:block">{group.label}:</span>
            <div className="flex flex-wrap gap-1">
              {group.options.map(opt => (
                <button
                  key={opt.value}
                  onClick={() => group.onChange(opt.value)}
                  className={`text-[10px] tracking-widest uppercase px-3 py-1.5 rounded-full border transition-all whitespace-nowrap cursor-pointer ${
                    group.value === opt.value
                      ? 'bg-[#c9a84c] border-[#c9a84c] text-black font-bold'
                      : 'border-white/15 text-white/50 hover:border-[#c9a84c]/40 hover:text-white/80'
                  }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        ))}

        {/* Sort */}
        <select
          value={sortValue}
          onChange={e => onSortChange(e.target.value)}
          className="bg-white/5 border border-white/15 text-white/70 text-xs rounded-md px-3 py-2.5 focus:outline-none focus:border-[#c9a84c]/50 transition-colors cursor-pointer appearance-none pr-8 relative"
          style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c9a84c' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\")", backgroundRepeat: 'no-repeat', backgroundPosition: 'right 10px center' }}
        >
          {sortOptions.map(opt => (
            <option key={opt.value} value={opt.value} className="bg-[#111111] text-white">
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ShopFilters;
